export const compressImage = (file, maxWidth = 800, maxHeight = 800, quality = 1) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        reject(new Error("No file provided"));
        return;
      }
  
      // Skip compression if file size is ≤ 1024 KB
      if (file.size <= 1024 * 1024) {
        console.log("Skipping compression for:", file.name, "Size:", file.size);
        resolve(file);
        return;
      }
  
      const reader = new FileReader();
      reader.readAsDataURL(file);
  
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          let width = img.width;
          let height = img.height;
  
          // Maintain aspect ratio while resizing
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
  
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
  
          // Improve quality by using high-quality interpolation
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = "high";
          
  
          ctx.drawImage(img, 0, 0, width, height);
  
          // Convert canvas to compressed file (use WebP for better quality)
          canvas.toBlob(
            (blob) => {
              if (blob) {
                resolve(new File([blob], file.name, { type: "image/webp" })); // WebP maintains better quality
              } else {
                reject(new Error("Compression failed"));
              }
            },
            "image/webp", // Change format to WebP
            quality // Adjust compression quality (0.8 - 1.0 for better results)
          );
        };
      };
  
      reader.onerror = (error) => reject(error);
    });
  };
  